import * as React from "react";
import TicketAppBar from "./TicketAppBar";
import { GlobalContext, GlobalContextValue } from "../Utils/Contexts";
import { PersonExtended } from "../Utils/TypeExtensions";
import dayjs from "dayjs";
import { PilotDutyPage } from "./PilotDutyPage";

interface AppContainerProps {
    setAuthorizationToken(newToken: string): void;
    personId: string | null;
    setPersonId(newPersonId: string): void;
}

export const SERVER_DATE_FORMAT = "YYYY-MM-DD";
export default function AppContainer(props: AppContainerProps): JSX.Element {
    const [globalContextValue, setGlobalContextValue] = React.useState<GlobalContextValue>({
        setSelectedPilot(newPilot: PersonExtended) {
            handleSetSelectedPilot(newPilot);
        },
        setLoggedInUser(user: PersonExtended) {
            handleSetLoggedInUser(user);
        },
        setSelectedDate(newDate: string) {
            handleSetSelectedDate(newDate);
        },
        setSelectedDatesList(addDate: string) {
            handleSetSelectedDatesList(addDate);
        },
    } as GlobalContextValue);

    function handleSetSelectedPilot(newPilot: PersonExtended) {
        setGlobalContextValue((prev) => {
            return { ...prev, selectedPilot: newPilot };
        });
    }

    function handleSetSelectedDate(newDate: string) {
        newDate = newDate ? dayjs(newDate).format(SERVER_DATE_FORMAT) : "";
        setGlobalContextValue((prev) => {
            return { ...prev, selectedDate: newDate };
        });
    }

    const handleSetLoggedInUser = (user: PersonExtended) => {
        setGlobalContextValue((prev) => {
            return { ...prev, loggedInUser: user };
        });
    };

    const handleSetSelectedDatesList = (addDate: string) => {
        setGlobalContextValue((prev) => {
            let list = prev.selectedDatesList ? prev.selectedDatesList.slice() : [];

            // if already present then don't duplicate
            if (list.includes(addDate)) return prev;

            if (list.length === 0) list = [addDate];
            else list = [...list, addDate];

            return { ...prev, selectedDatesList: list };
        });
    };

    return (
        <>
            <GlobalContext.Provider value={globalContextValue}>
                <TicketAppBar setAuthorizationToken={props.setAuthorizationToken} setPersonId={props.setPersonId} />
                {globalContextValue.loggedInUser ? <PilotDutyPage /> : null}
            </GlobalContext.Provider>
        </>
    );
}
